import { render, staticRenderFns } from "./PreviewImgListItem.vue?vue&type=template&id=50b93ef3"
import script from "./PreviewImgListItem.vue?vue&type=script&lang=ts"
export * from "./PreviewImgListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports